module.exports = __webpack_public_path__ + "img/Online-games.869a70b0.svg";